export default "__VITE_ASSET__CDxZd792__"